import * as Yup from 'yup';
import { StepAuthorForm } from './step-author-types';

export const stepAuthorSchema = () =>
  Yup.object<StepAuthorForm>().shape({
    author: Yup.mixed().nullable().required('Povinné pole'),
  });
